import { Checkbox as CheckboxMui, FormControlLabel, FormControlLabelProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

import { ReactComponent as CheckboxCheckedIcon } from './icons/CheckboxCheckedIcon.svg';
import { ReactComponent as CheckboxCheckedDisabledIcon } from './icons/CheckboxCheckedDisabledIcon.svg';
import { ReactComponent as CheckboxIcon } from './icons/CheckboxIcon.svg';
import { ReactComponent as CheckboxIndeterminateIcon } from './icons/CheckboxIndeterminateIcon.svg';
import { ReactComponent as CheckboxIndeterminateIconDisabled } from './icons/CheckboxIndeterminateIconDisabled.svg';

const CheckboxBase = withStyles(() => ({
  root: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  disabled: {
    backgroundColor: '#f2f2f4',
  },
}))(CheckboxMui);

const FormControlLabelBase = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    marginRight: 16,
  },
  label: {
    paddingLeft: theme.spacing(1),
    '&$disabled': {
      color: theme.palette.darkGrey[15],
    },
  },

  disabled: {
    color: theme.palette.darkGrey[15],
  },
}))(FormControlLabel);

interface Props extends FormControlLabelProps {
  isCheckedDisabled?: boolean;
  indeterminate?: boolean;
  defaultChecked?: boolean;
}

function Checkbox(props: Omit<Props, 'control'>) {
  const { defaultChecked, indeterminate, isCheckedDisabled, disabled, ...rest } = props;
  return (
    <FormControlLabelBase
      control={
        <CheckboxBase
          checkedIcon={isCheckedDisabled || disabled ? <CheckboxCheckedDisabledIcon /> : <CheckboxCheckedIcon />}
          defaultChecked={defaultChecked}
          disableRipple
          disabled={disabled}
          icon={<CheckboxIcon />}
          indeterminate={indeterminate}
          indeterminateIcon={
            isCheckedDisabled || disabled ? <CheckboxIndeterminateIconDisabled /> : <CheckboxIndeterminateIcon />
          }
        />
      }
      disabled={disabled}
      {...rest}
    />
  );
}

export default Checkbox;
